import { render, staticRenderFns } from "./LdpThongke.vue?vue&type=template&id=08a82f30&"
import script from "./LdpThongke.vue?vue&type=script&lang=js&"
export * from "./LdpThongke.vue?vue&type=script&lang=js&"
import style0 from "./LdpThongke.vue?vue&type=style&index=0&id=08a82f30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports